import t from "../../../../_virtual/memoize.js";
var r = t(function(i) {
  return {
    x: i.left,
    y: i.top,
    width: i.width,
    height: i.height
  };
}, function(i) {
  return ["l", i.left, "t", i.top, "w", i.width, "h", i.height].join("");
});
export {
  r as calculateViewBox
};
